import { render, staticRenderFns } from "./TouchpointStatisticsOverviewCell.vue?vue&type=template&id=753cd621&"
import script from "./TouchpointStatisticsOverviewCell.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsOverviewCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('753cd621')) {
      api.createRecord('753cd621', component.options)
    } else {
      api.reload('753cd621', component.options)
    }
    module.hot.accept("./TouchpointStatisticsOverviewCell.vue?vue&type=template&id=753cd621&", function () {
      api.rerender('753cd621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatisticsOverviewCell.vue"
export default component.exports